import store from "@/store";
import { Message } from "element-ui";
import { ShakenMode } from "@/service/storage";

// 予約をURLから取得するcustomer画面や一覧画面は対象外。
const reservationPaths = [
  "/factory/inspectiondetail",
  "/factory/additional-maintenance",
  "/factory/inspection",
  "/factory/completed",
  "/user/inspection",
  "/user/complete"
];

export async function checkReservation(to: any, next: any): Promise<void> {
  const required = to.matched.some((record: any) =>
    reservationPaths.indexOf(record.path.replace(/\/$/, "")) !== -1
  );
  if (!required) {
    next();
    return;
  }

  const mode: ShakenMode = to.meta === "user" ? "user" : "factory";

  try {
    const ready = await store.dispatch("ReservationDetail/ensureState", mode);
    if (!ready) {
      next(false);
      window.location.href = mode === "user" ? "/user/reservationNumber" : "/factory/reservation";
      return;
    }
    next();
  } catch (error) {
    next(false);
    Message.error("予約情報を取得できませんでした。通信状態を確認して再読み込みしてください。");
  }
}
